import React, { Component } from "react";
import PropTypes from "prop-types";
import Select from "../Select/Select";
import Field from "../../components/Common/Field/Field";

class TrimMainSection extends Component {

  render() {
    const { trimOptions, trim, onSelect, disabled } = this.props;
    return (
      <div className="col-md-12 nopadding">
        <div className="col-md-5 nopadding">
          {/* FORM GROUP */}
          <div class="ib-list-view  mb-0 p-0 listFieldWrapper">
            <ul class="main-list">
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* TRIM CAT */}
                  <li class="text-right">Trim Category</li>
                  <li>
                    <Select
                      options={trimOptions.trimCatOptions}
                      name={"trimCategory"}
                      onSelect={onSelect}
                      disabled={disabled}
                      value={trim.trimCategory}
                    />
                  </li>
                </ul>
              </li>
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* description */}
                  <li class="text-right">Description</li>
                  <li>
                    <Select
                      options={trimOptions.trimDescOptions}
                      name={"description"}
                      onSelect={onSelect}
                      disabled={disabled}
                      value={trim.description}
                    />
                  </li>
                </ul>
              </li>
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* color */}
                  <li class="text-right">Color</li>
                  <li>
                    <Select
                      options={trimOptions.trimColorOptions}
                      name={"color"}
                      onSelect={onSelect}
                      disabled={disabled}
                      value={trim.color}
                    />
                  </li>
                </ul>
              </li>
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* quality */}
                  <li class="text-right">Quality</li>
                  <li>
                    <Select
                      options={trimOptions.trimQualityOptions}
                      name={"quality"}
                      onSelect={onSelect}
                      disabled={disabled}
                      value={trim.quality}
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        <div className="col-md-5 nopadding">
          {/* FORM GROUP */}
          <div class="ib-list-view  mb-0 p-0 listFieldWrapper">
            <ul class="main-list">
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* Trim Ref No */}
                  <li class="text-right">Trim Ref No.</li>
                  <li>
                    <input
                      type="text"
                      className="form-control"
                      disabled={true}
                      value={trim.trimRefNumber}
                    />
                  </li>
                </ul>
              </li>
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* Supplier Ref No */}
                  <li class="text-right">Supplier Ref No.</li>
                  <li>
                    <input
                      type="text"
                      className="form-control"
                      name={"supplierRef"}
                      onChange={(e) => onSelect(e.target.name, e.target.value)}
                      disabled={disabled}
                      value={trim.supplierRef}
                    />
                  </li>
                </ul>
              </li>
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* SIZE */}
                  <li class="text-right">Size</li>
                  <li>
                    <ul>
                      <li className="p-0">
                        <Select
                          options={trimOptions.trimSizeOptions1}
                          name={"sizeNumber"}
                          onSelect={onSelect}
                          disabled={disabled}
                          value={trim.sizeNumber}
                        />
                      </li>
                      <li className="p-0">
                        <Select
                          options={trimOptions.trimSizeOptions2}
                          name={"size"}
                          onSelect={onSelect}
                          disabled={disabled}
                          value={trim.size}
                        />
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
              {/* FORM FIELD */}
              <li>
                <ul>
                  {/* UNITS */}
                  <li class="text-right">Units</li>
                  <li>
                    <Select
                      options={trimOptions.TRIMUNITS}
                      name={"unit"}
                      onSelect={onSelect}
                      disabled={disabled}
                      value={trim.unit}
                    />
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
        {/* special comments */}
        <div class="col-md-12 nopadding px-5">
          <Field
            inputType="textarea"
            inputName="comments"
            label="comments"
            onChange={onSelect}
            disabled={disabled}
            value={trim.comments}
          />
        </div>
      </div>
    );
  }
}
TrimMainSection.defaultProps = {
  trimOptions: {},
  trim: {},
  disabled: false
};

export default TrimMainSection;



// WEBPACK FOOTER //
// ./src/components/TrimMainSection/TrimMainSection.js